$("#laeg-i-kurv-modal, #design-wizard").click(function(event) {
  calulatePrice();
  generateOverviewTable();
});

$("input[name=delivery-type]").change(function() {
  calulatePrice();
  generateOverviewTable();
});

var continueShopping = false;
var submitting = false;

function goToAddons(target) {
  var selector = continueShopping ? "#AddToCartAndShopText" : "#AddToCartText";
  $("#AddAddonsToCart span").text($(selector).text());

  $(".delivery-modal").modal("hide");
  $("#bs-modal-addon").modal("show");
  $(".loader").addClass("hide");
}

function addDeliveryToCart() {
  return new Promise(function(res, rej) {
    var did =
      Math.random()
        .toString(36)
        .substr(2) +
      Math.random()
        .toString(36)
        .substr(2);

    document.getElementById("did").value = did;

    if ($("input[name=delivery-type]:checked").length == 0) {
      return res();
    }

    console.log("adding delivery...");

    $.post(
      "/cart/add.js",
      {
        quantity: 1,
        id: $("input[name=delivery-type]:checked").attr("data-id"),
        properties: { pid: did }
      },
      res,
      "json"
    ).always(res);
  });
}

function submitProductForm() {
  // Set flag to redirect to collection when cart is hit
  if (continueShopping) {
    var redirectTo = window.location.origin.indexOf('.se') !== -1 ? "/collections/alla" : "/collections/all";
    window.localStorage.setItem("redirect-to", redirectTo);
  }

  $("#AddToCartForm").submit();

  return;
}

function progressAndContinueShopping(b) {
  return function() {
    if (submitting) {
      return;
    }

    continueShopping = b;

    $("#NejTak span").text(
      continueShopping
        ? "Nej tak - forts\xE6t med at handle uden tilbeh\xF8r"
        : "Nej tak - forts\xE6t til kassen uden tilbeh\xF8r"
    );

    $("#AddToCartAndShop .loader").removeClass("hide");
    if (!productInfo.additionalPurchases) {
      submitting = true;
      $("#AddToCart .loader, #NejTak .loader").removeClass("hide");
      addDeliveryToCart().then(submitProductForm);
    } else {
      goToAddons();
    }
  };
}

$("#AddToCart").click(progressAndContinueShopping(false));

$("#AddToCartAndShop").click(function () {
  progressAndContinueShopping(true)();
  // Set storage item to open cart
  sessionStorage.setItem('requestOpenCart', 'yes');
});

$("#NejTak").click(function() {
  if (submitting) {
    return;
  }

  submitting = true;
  $("#AddToCart .loader, #NejTak .loader").removeClass("hide");
  addDeliveryToCart().then(submitProductForm);
});

function addExtraItemToCart(input) {
  return new Promise(function(res, rej) {
    var me = $(input);
    var quantity = parseFloat(me.val());
    var id = me.attr("data-id");

    if (id && quantity > 0) {
      $.post("/cart/add.js", { quantity: quantity, id: id })
        .done(function() {
          res(true);
        })
        .fail(function(e) {
          // TODO: Reject
          res(false);
        });
    } else {
      res(false);
    }
  });
}

$("#AddAddonsToCart").click(function(e) {
  e.preventDefault();

  if (submitting) {
    return;
  }

  submitting = true;

  $("#AddAddonsToCart .loader").removeClass("hide");

  var sum = 0;
  var queue = $.makeArray($(".addon-item .addon-item--amount input"));

  queue
    .reduce(function(last, input) {
      return last.then(function() {
        return addExtraItemToCart(input).then(function(added) {
          sum += added;
        });
      });
    }, Promise.resolve())
    .then(function() {
      console.log(
        "we are all the way trough! we added",
        sum,
        "out of potentially",
        queue.length,
        "extra items!"
      );

      addDeliveryToCart().then(submitProductForm);
    });
});

function calulatePrice() {
  var qty = $("#Quantity").val() || 1;
  var price = parseFloat($("#ProductPrice").attr("data-price")) * qty;

  if ($("input[name=delivery-type]:checked").length > 0) {
    price += parseFloat(
      $("input[name=delivery-type]:checked").attr("data-price")
    );
  }

  $("#price-with-delivery").html(formatPrice(price / 100));
}

function generateVariantSelectionHTML() {
  var fields = {
    Antal: 1
  };

  $(
    "#AddToCartForm > label, #AddToCartForm > .selector-wrapper label, #AddToCartForm > .row label"
  ).each(function() {
    var key = this.textContent;
    var valueHolder = this.htmlFor;
    var value = $("#" + valueHolder).val();

    fields[key] = value;
  });
  /*
  var optionLabel = [];
  var option = [];

  $(
    '#infiniteoptions-container label, .selector-wrapper label'
  ).each(function() {
    if ($(this).html().indexOf('//') == -1) {
      optionLabel.push($(this).html());
    }
  });

  $(
    '#infiniteoptions-container select, .selector-wrapper select'
  ).each(function() {
    if ($(this).html().indexOf('//') == -1) {
      option.push($(this).val());
    }
  });
  var html = '';

  for (var i = 0; i < option.length; i++) {
    if (//optionLabel[i] == 'Antal' && productInfo.skewedQuantity
      option[i] == 'Default Title' && false) {
      continue;
    }

    var label = optionLabel[i];
    var value = html += '<tr id="tempname-' +
      optionLabel[i].replace(/\s/g, '') +
      '"><td>' +
      label +
      '</td><td>' +
      option[i] +
      '</td></tr>';
  }
*/

  var html = Object.keys(fields)
    .map(function(key) {
      return (
        "<tr>" +
        "<td>" +
        key +
        "</td>" +
        '<td id="option-id-' +
        key.replace(/\s/g, "") +
        '">' +
        fields[key] +
        "</td>" +
        "</tr>"
      );
    })
    .join("");

  return html;
}

function generateOverviewTable() {
  $("#product-overview-table").html(
    [
      "<tr>",
      "<td>Produkt</td>",
      "<td>",
      $("#title").html(),
      "</td>",
      "</tr>",
      generateVariantSelectionHTML(),
      $("input[name=delivery-type]:checked").length > 0
        ? [
            '<tr id="product-delevery-row"><td>Produktionstid</td><td>',
            $("input[name=delivery-type]:checked").attr("data-title"),
            "</td></tr>"
          ].join("")
        : ""
    ].join("")
  );
}

function formatPrice(price) {
  var formattedPrice = price
    .toFixed(2)
    .replace(".", ",")
    .replace(/(\d)(?=(\d{3})+\,)/g, "$1.");

  formattedPrice = formattedPrice.replace(",00", ",-");

  return formattedPrice;
}
